import * as actionTypes from 'store/actions/actionTypes';

const initState = {
  loading: false,
  uploads: [],
};

export default (state = initState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_INV_UPLOADS_START:
      return { ...state, loading: true };

    case actionTypes.FETCH_INV_UPLOADS_END:
      return {
        ...state,
        loading: false,
        uploads: action.data.inventory_uploads,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/inventory.js